import { render, staticRenderFns } from "./CuotaCard.vue?vue&type=template&id=2f75ad61&scoped=true"
import script from "./CuotaCard.vue?vue&type=script&lang=js"
export * from "./CuotaCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f75ad61",
  null
  
)

export default component.exports